import { render, staticRenderFns } from "./lopperEdit.vue?vue&type=template&id=b3f15dc4&scoped=true"
import script from "./lopperEdit.vue?vue&type=script&lang=js"
export * from "./lopperEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f15dc4",
  null
  
)

export default component.exports